<template>
  <div class="container">
    <div class="title">订单详情</div>
    <div class="header">
      <div class="status_text">{{ statusText(detail.status) }}</div>
      <div
        class="see_logistics"
        v-if="[5, 14, 10, 6, 11].includes(detail.status)"
        @click="seeLogistics"
      >
        查看物流
      </div>
    </div>
    <div class="content">
      <div class="user_info_box content_box">
        <div class="user_item">
          <div class="user_info_title">下单用户</div>
          <div class="user_info">
            <img
              :src="
                detail.photo
                  ? detail.photo
                  : 'https://hospital-runsheng.oss-cn-shenzhen.aliyuncs.com/runsheng-wx/avatar.png'
              "
              alt=""
            />
            <div class="user_info_text">
              <div>{{ detail.userName }}</div>
              <span>{{ detail.userMobile }}</span>
            </div>
          </div>
        </div>
        <div class="user_item">
          <div class="user_info_title">归属工作室</div>
          <div class="user_info">
            <img
              :src="
                detail.studioAvatar
                  ? detail.studioAvatar
                  : 'https://hospital-runsheng.oss-cn-shenzhen.aliyuncs.com/runsheng-wx/avatar.png'
              "
              alt=""
            />
            <div class="user_info_text">
              <div>{{ detail.studioName }}</div>
              <span>{{ detail.studioPhone }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="user_address_box content_box">
        <div class="user_address_top">
          {{ detail.receiverName }} {{ detail.receiverPhone }}
        </div>
        <div class="user_address_bottom">
          {{ detail.receiverAddress }}
        </div>
      </div>
      <div class="medicine_box content_box">
        <div class="organization">
          <div class="organization_left">
            <img
              src="https://hospital-runsheng.oss-cn-shenzhen.aliyuncs.com/runsheng-wx/avatar.png"
              alt=""
            />
            <span>润生医疗</span>
          </div>
          <div class="organization_right" @click="onViewImgs">
            <span>关联电子处方</span><van-icon name="arrow"/>
          </div>
        </div>
        <div class="chinese_medicine" v-if="detail.preType==2">
          <div
            class="chinese_medicine_name"
            v-for="(chinesItem, chineseIndex) in detail.prescriptionDetailList"
            :key="chineseIndex"
          >
            {{ chinesItem.drugName }}
          </div>
        </div>
        <div class="box_packed_drug" v-if="detail.preType==1" >
          <div class="drug_info" v-for="val in detail.prescriptionDetailList" :key="val.id">
            <div class="drug_name_sku">
              <div class="drug_name">{{ val.drugName }}
                <span class="drug_sku">（{{ val.drugSpecifications }}）</span>
              </div>
            </div>
            <div class="drug_num_price">×{{ val.quantity }}</div>
          </div>
        </div>
        <div class="medicine_bottom">
          <div class="item_box">
            <div class="item_label">用药人信息</div>
            <div class="item_value">
              {{ detail.userMemberName }}
              {{ detail.userMemberSex == 1 ? "男" : "女" }}
              {{ detail.userMemberAge }}岁
            </div>
          </div>
          <div class="item_box">
            <div class="item_label">问诊记录</div>
            <div class="item_value" @click="inquiryRecord(detail.userMemberId)">
              查看详情
              <van-icon name="arrow"/>
            </div>
          </div>
        </div>
      </div>
      <div class="order_money_box content_box">
        <div class="item_box">
          <div class="item_label">药品总额</div>
          <div class="item_value">￥{{ Number(detail.amountDrugs) || 0 }}</div>
        </div>
        <template v-if="detail.extFeeJson">
          <div
            class="item_box"
            v-for="(item, index) in JSON.parse(detail.extFeeJson)"
            :key="index"
          >
            <div class="item_label">{{ item.feeName }}</div>
            <div class="item_value">￥{{ item.feePrice }}</div>
          </div>
        </template>

        <div v-show="detail.preType == 2" class="item_box">
          <div class="item_label">代煎费</div>
          <div class="item_value">￥{{ Number(detail.platformFriedFee) }}</div>
        </div>
        <div class="item_box">
          <div class="item_label">物流费</div>
          <div class="item_value">￥{{ Number(detail.shippingFee) }}</div>
        </div>
        <div class="item_box item_box_split">
          <div class="item_label"></div>
          <div class="item_value">
            合计：<span>￥{{ Number(detail.orderMoney) || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="content_box">
        <div class="item_box">
          <div class="item_label">订单编号</div>
          <div class="item_value">
            {{ detail.orderNo
            }}<span class="copy" @click="copy(detail.orderNo)">复制</span>
          </div>
        </div>
      </div>
    </div>

    <div class="foot">
      <van-button class="button" @click="goBlack">返回</van-button>
    </div>
  </div>
</template>
<script>
import { getDrugOrderDetail } from "@/api/home.js";
import BigNumber from "bignumber.js";
import { getDoctorPrescriptionByaskNo } from "@/api/ask";
export default {
  name: "drugDetail",
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    statusText(status) {
      let statusStr = "";
      if (status == 0) {
        statusStr = "待付款";
      } else if (status == 1) {
        statusStr = "已支付";
      } else if (status == 2) {
        statusStr = "已关闭";
      } else if (status == 3) {
        statusStr = "已关闭";
      } else if (status == 4) {
        statusStr = "待发货";
      } else if (status == 5) {
        statusStr = "待收货";
      } else if (status == 6) {
        statusStr = "已完成";
      } else if (status == 7) {
        statusStr = "已退货";
      } else if (status == 8) {
        statusStr = "已关闭（订单已退款）";
      } else if (status == 9) {
        statusStr = "拼团中（活动）";
      } else if (status == 10) {
        statusStr = "已完成";
      } else if (status == 11) {
        statusStr = "已完成";
      } else if (status == 12) {
        statusStr = "面单已打印";
      } else if (status == 13) {
        statusStr = "待自取";
      } else if (status == 14) {
        statusStr = "待收货";
      } else if (status == -1) {
        statusStr = "待审核";
      } else {
        statusStr = "未知";
      }
      return statusStr;
    },
    goBlack() {
      this.$router.back();
    },
    seeLogistics() {
      this.$router.push({
        path: "/inquiryInfo/logistics",
        query: {
          askNo: this.detail.orderNo,
          shippingCompName:this.$route.query.shippingCompName
        },
      });
    },
    async onViewImgs() {
      const { data } = await getDoctorPrescriptionByaskNo({
        askNo: this.detail.askNo,
        statusArry: "1,2,6,7",
        pageNo: 1,
        pageSize: 50,
      });
      let imgs = data.list
        .map((item) => process.env.VUE_APP_IMG_HOST + item.url)
        .reverse();
      this.$viewerApi({
        images: imgs,
        options: {
          title: false,
        },
      });
    },
    copy(value) {
      const input = document.createElement("input");
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$toast("复制成功");
    },
    getDetail() {
      let data = {
        orderNo: this.$route.query.orderNo, //
        status: this.$route.query.orderStatus, //
      };
      getDrugOrderDetail(data).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.detail = res.data;
          this.detail.amountDrugs = Number(
            new BigNumber(Number(this.detail.totalFee))
              .minus(Number(this.detail.discount))
              .minus(Number(this.detail.extFee))
          );
          this.detail.orderMoney = Number(
            new BigNumber(Number(this.detail.totalFee))
              .plus(Number(this.detail.shippingFee))
              .plus(Number(this.detail.platformFriedFee))
              .minus(Number(this.detail.discount))
          );
        }
      });
    },
    inquiryRecord(id) {
      this.$router.push({
        path: "/inquiryRecord",
        query: {
          userMemberId: id,
          pageNo: 1,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  padding-top: 40px;
  padding-bottom: 50px;
  height: 100%;
  box-sizing: border-box;
}
.title {
  position: fixed;
  top: 0;
  z-index: 99;
  background: #fff;
  width: 100%;
  line-height: 40px;
  text-align: center;
}
.header {
  width: 100%;
  padding: 24px 16px 41px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  box-sizing: border-box;
  background: rgb(25, 137, 250);
  font-size: 18px;
  .status_text {
  }
  .see_logistics {
    font-size: 16px;
    padding: 4px;
    border: 1px solid #fff;
  }
}
.content {
  .content_box {
    width: 95%;
    margin: 0 auto;
    margin-bottom: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    .item_box {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;
      .item_label {
        color: #7c807f;
        font-size: 14px;
      }
      .item_value {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 700;
        span {
          color: rgb(192, 142, 11);
        }
        .copy {
          margin-left: 8px;
          padding: 4px;
          border-radius: 4px;
          color: #fff;
          display: inline-block;
          background: rgb(25, 137, 250);
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
    .item_box:last-child {
      margin-bottom: 0;
    }
  }
  .user_info_box {
    margin-top: -16px;
    display: flex;
    justify-content: space-between;
    .user_item {
      .user_info_title {
        margin-bottom: 8px;
        font-size: 16px;
        color: #261b11;
        font-weight: 700;
      }
      .user_info {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          border-radius: 50%;
        }
        .user_info_text {
          display: flex;
          flex-direction: column;
          div {
            font-size: 16px;
          }
          span {
            font-size: 14px;
          }
        }
      }
    }
  }

  .user_address_box {
    .user_address_top {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 8px;
    }
    .user_address_bottom {
      font-size: 14px;
    }
  }
  .medicine_box {
    line-height: 1;
    .organization {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .organization_left {
        display: flex;
        align-items: center;
        img {
          margin-right: 8px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
        span {
          font-size: 16px;
          font-weight: 700;
        }
      }
      .organization_right {
        display: flex;
        align-items: center;
        font-weight: 700;
        span {
          font-size: 15px;
        }
      }
    }
    .chinese_medicine {
      display: flex;
      flex-wrap: wrap;

      .chinese_medicine_name {
        margin-bottom: 16px;
        width: 33%;
        font-size: 14px;
        text-align: center;
      }
    }
    .western_medicine {
    }
    .medicine_bottom {
      padding-top: 16px;
      border-top: 1px solid #eee;
      /* .item_box {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 1;
        .item_label {
          color: #7c807f;
          font-size: 14px;
        }
        .item_value {
          font-size: 15px;
          font-weight: 700;
          span {
            color: rgb(192, 142, 11);
          }
        }
      } */
    }
  }

  .box_packed_drug {
    
      margin-top: 20px;
      padding-bottom: 16px;
      display: grid;
      grid-template-columns: 1fr;
      row-gap: 18px;
      box-sizing: border-box;
      .drug_info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .drug_name_sku {
          display: flex;
          flex-direction: row;
          font-weight: 400;
          font-size: 15px;
          color: #1B2120;
          word-break: break-all;
          max-width: 219px;

          .drug_name {
          }

          .drug_sku {
            color: #5C5E5E;
          }
        }

        .drug_num_price {
          font-weight: 400;
          font-size: 14px;
          color: #5C5E5E;
        }
      }

    }
  .order_money_box {
    .item_box_split {
      padding-top: 16px;
      border-top: 1px solid #eee;
    }
    /* .item_box {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;
      .item_label {
        color: #7c807f;
        font-size: 14px;
      }
      .item_value {
        font-size: 15px;
        font-weight: 700;
        span {
          color: rgb(192, 142, 11);
        }
      }
    } */
  }
}
.foot {
  width: 95%;
  position: fixed;
  left: 2.5%;
  bottom: 0;
  .button {
    width: 100%;
    border-radius: 6px;
    background: rgb(25, 137, 250);
    color: #fff;
  }
}
</style>